import { actions } from "@grandvisionhq/state";
const fetchLensTypes = actions.action(
  "products/prescription-glasses/fetch-lens-types",
  actions.payload()
);
const fetchLensTypesSuccess = actions.action(
  "products/prescription-glasses/fetch-lens-types-success",
  actions.payload()
);
const fetchLensTypesFailed = actions.action(
  "products/prescription-glasses/fetch-lens-types-failed",
  actions.payload()
);
const fetchPackages = actions.action(
  "products/prescription-glasses/fetch-packages",
  actions.payload()
);
const fetchPackagesSuccess = actions.action(
  "products/prescription-glasses/fetch-packages-success",
  actions.payload()
);
const fetchPackagesFailed = actions.action(
  "products/prescription-glasses/fetch-packages-failed",
  actions.payload()
);
const fetchAddOns = actions.action(
  "products/prescription-glasses/fetch-add-ons",
  actions.payload()
);
const fetchAddOnsSuccess = actions.action(
  "products/prescription-glasses/fetch-add-ons-success",
  actions.payload()
);
const fetchAddOnsFailed = actions.action(
  "products/prescription-glasses/fetch-add-ons-failed",
  actions.payload()
);
export {
  fetchAddOns,
  fetchAddOnsFailed,
  fetchAddOnsSuccess,
  fetchLensTypes,
  fetchLensTypesFailed,
  fetchLensTypesSuccess,
  fetchPackages,
  fetchPackagesFailed,
  fetchPackagesSuccess
};
//# sourceMappingURL=actions.js.map
